var map = {
	"./decidim/avatar-multiuser.png": 34119,
	"./decidim/brands/facebook.svg": 55895,
	"./decidim/brands/google.svg": 78718,
	"./decidim/brands/twitter-x.svg": 6039,
	"./decidim/cc-badge.png": 29517,
	"./decidim/decidim-logo.svg": 69269,
	"./decidim/default-avatar.svg": 71189,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 11595,
	"./decidim/icons.svg": 54564,
	"./decidim/pattern.png": 21751,
	"./decidim/placeholder-card-g.svg": 86636,
	"./decidim/placeholder-card-l.svg": 58903,
	"./decidim/placeholder.jpg": 58414,
	"./decidim/remixicon.symbol.svg": 71396,
	"./decidim/vendor/social-share-button/douban.svg": 23351,
	"./decidim/vendor/social-share-button/email.svg": 34272,
	"./decidim/vendor/social-share-button/facebook.svg": 10127,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 95384,
	"./decidim/vendor/social-share-button/hacker_news.svg": 42932,
	"./decidim/vendor/social-share-button/linkedin.svg": 23334,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 92575,
	"./decidim/vendor/social-share-button/pinterest.svg": 5838,
	"./decidim/vendor/social-share-button/reddit.svg": 89572,
	"./decidim/vendor/social-share-button/telegram.svg": 76969,
	"./decidim/vendor/social-share-button/tumblr.svg": 56774,
	"./decidim/vendor/social-share-button/twitter.svg": 59037,
	"./decidim/vendor/social-share-button/vkontakte.svg": 9119,
	"./decidim/vendor/social-share-button/wechat.svg": 97930,
	"./decidim/vendor/social-share-button/whatsapp.svg": 61258,
	"./decidim/vendor/social-share-button/x.svg": 30208,
	"./decidim/vendor/social-share-button/xing.svg": 30376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4864;